import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

type State = {
	hasNeedsBasedQuestions: boolean;
	needsBasedAnswers: Record<string, string[]> | undefined;
	questionnaireId: string;
};

type Actions = {
	setHasNeedsBasedQuestions: (bool: boolean) => void;
	setNeedsBasedAnswers: (answers: Record<string, string[]>) => void;
	setQuestionnaireId: (questionnaireId: string) => void;
};

const useNeedsBasedQuestionsStore = create<State & Actions>((set) => ({
	hasNeedsBasedQuestions: false,
	setHasNeedsBasedQuestions: (hasNeedsBasedQuestions) => set({ hasNeedsBasedQuestions }),
	needsBasedAnswers: undefined,
	setNeedsBasedAnswers: (needsBasedAnswers) => set({ needsBasedAnswers }),
	questionnaireId: '',
	setQuestionnaireId: (questionnaireId) => set({ questionnaireId }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('needsBasedQuestionsStore', useNeedsBasedQuestionsStore);
}

export default useNeedsBasedQuestionsStore;
